export default __webpack_public_path__ + "static/media/Here.6271b62b.png";